import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Tata_finance_master extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.tata_finance_master_Id,
          sortable: true,
          cell: (row) => <span>{row.tata_finance_master_Id}</span>,
        },
        { name: "Number Financier Cd", selector: (row, i) => row.num_financier_cd, sortable: true, cell: (row) => <span>{row.num_financier_cd}</span>, }, { name: "Text Financier Short Name", selector: (row, i) => row.txt_financier_short_name, sortable: true, cell: (row) => <span>{row.txt_financier_short_name}</span>, }, { name: "Text Financier Name", selector: (row, i) => row.txt_financier_name, sortable: true, cell: (row) => <span>{row.txt_financier_name}</span>, }, { name: "Text Financier Type", selector: (row, i) => row.txt_financier_type, sortable: true, cell: (row) => <span>{row.txt_financier_type}</span>, }, { name: "Text Status", selector: (row, i) => row.txt_status, sortable: true, cell: (row) => <span>{row.txt_status}</span>, }, { name: "Text IFSC Code", selector: (row, i) => row.txt_ifsc_code, sortable: true, cell: (row) => <span>{row.txt_ifsc_code}</span>, }, { name: "Text Micr Code", selector: (row, i) => row.txt_micr_code, sortable: true, cell: (row) => <span>{row.txt_micr_code}</span>, }, { name: "Text Lisence Number", selector: (row, i) => row.txt_lisence_no, sortable: true, cell: (row) => <span>{row.txt_lisence_no}</span>, }, { name: "Text PAN Number", selector: (row, i) => row.txt_pan_no, sortable: true, cell: (row) => <span>{row.txt_pan_no}</span>, }, { name: "Date Block Date", selector: (row, i) => row.dat_block_date, sortable: true, cell: (row) => <span>{row.dat_block_date}</span>, }, { name: "Date Start Date", selector: (row, i) => row.dat_start_date, sortable: true, cell: (row) => <span>{row.dat_start_date}</span>, }, { name: "Date End Date", selector: (row, i) => row.dat_end_date, sortable: true, cell: (row) => <span>{row.dat_end_date}</span>, }, { name: "Date Insert Date", selector: (row, i) => row.dat_insert_date, sortable: true, cell: (row) => <span>{row.dat_insert_date}</span>, }, { name: "Date Modify Date", selector: (row, i) => row.dat_modify_date, sortable: true, cell: (row) => <span>{row.dat_modify_date}</span>, }, { name: "C Uid", selector: (row, i) => row.c_uid, sortable: true, cell: (row) => <span>{row.c_uid}</span>, }, { name: "C Ts", selector: (row, i) => row.c_ts, sortable: true, cell: (row) => <span>{row.c_ts}</span>, }, { name: "last Update", selector: (row, i) => row.lastupdate, sortable: true, cell: (row) => <span>{row.lastupdate}</span>, }, { name: "U Ts", selector: (row, i) => row.u_ts, sortable: true, cell: (row) => <span>{row.u_ts}</span>, }, { name: "Date_end_date", selector: (row, i) => row.date_end_date, sortable: true, cell: (row) => <span>{row.date_end_date}</span>, }, { name: "Date_modify_date", selector: (row, i) => row.date_modify_date, sortable: true, cell: (row) => <span>{row.date_modify_date}</span>, }, { name: "Date Insert Date2", selector: (row, i) => row.date_insert_date, sortable: true, cell: (row) => <span>{row.date_insert_date}</span>, }, { name: "C UId Two", selector: (row, i) => row.c_uid_Two, sortable: true, cell: (row) => <span>{row.c_uid_Two}</span>, }, { name: "C Ts Two", selector: (row, i) => row.c_tsTwo, sortable: true, cell: (row) => <span>{row.c_tsTwo}</span>, }, { name: "Last Update Two", selector: (row, i) => row.lastupdateTwo, sortable: true, cell: (row) => <span>{row.lastupdateTwo}</span>, }, { name: "U Ts Two", selector: (row, i) => row.u_tsTwo, sortable: true, cell: (row) => <span>{row.u_tsTwo}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Tata_finance_mastereditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      tata_finance_master_Id: "",
      num_financier_cd: '', txt_financier_short_name: '', txt_financier_name: '', txt_financier_type: '', txt_status: '', txt_ifsc_code: '', txt_micr_code: '', txt_lisence_no: '', txt_pan_no: '', dat_block_date: '', dat_start_date: '', dat_end_date: '', dat_insert_date: '', dat_modify_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '', date_end_date: '', date_modify_date: '', date_insert_date: '', c_uid_Two: '', c_tsTwo: '', lastupdateTwo: '', u_tsTwo: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'num_financier_cd', inputType: 'Text', displayName: 'Number Financier Cd', validationOptions: { isRequired: false } },
      { fieldName: 'txt_financier_short_name', inputType: 'Text', displayName: 'Text Financier Short Name', validationOptions: { isRequired: false } },
      { fieldName: 'txt_financier_name', inputType: 'Text', displayName: 'Text Financier Name', validationOptions: { isRequired: false } },
      { fieldName: 'txt_financier_type', inputType: 'Text', displayName: 'Text Financier Type', validationOptions: { isRequired: false } },
      { fieldName: 'txt_status', inputType: 'Text', displayName: 'Text Status', validationOptions: { isRequired: false } },
      { fieldName: 'txt_ifsc_code', inputType: 'Text', displayName: 'Text IFSC Code', validationOptions: { isRequired: false } },
      { fieldName: 'txt_micr_code', inputType: 'Text', displayName: 'Text Micr Code', validationOptions: { isRequired: false } },
      { fieldName: 'txt_lisence_no', inputType: 'Text', displayName: 'Text Lisence Number', validationOptions: { isRequired: false } },
      { fieldName: 'txt_pan_no', inputType: 'Text', displayName: 'Text PAN Number', validationOptions: { isRequired: false } },
      { fieldName: 'dat_block_date', inputType: 'Date', displayName: 'Date Block Date', validationOptions: { isRequired: false } },
      { fieldName: 'dat_start_date', inputType: 'Text', displayName: 'Date Start Date', validationOptions: { isRequired: false } },
      { fieldName: 'dat_end_date', inputType: 'Text', displayName: 'Date End Date', validationOptions: { isRequired: false } },
      { fieldName: 'dat_insert_date', inputType: 'Date', displayName: 'Date Insert Date', validationOptions: { isRequired: false } },
      { fieldName: 'dat_modify_date', inputType: 'Date', displayName: 'Date Modify Date', validationOptions: { isRequired: false } },
      { fieldName: 'c_uid', inputType: 'Text', displayName: 'C Uid', validationOptions: { isRequired: false } },
      { fieldName: 'c_ts', inputType: 'Text', displayName: 'C Ts', validationOptions: { isRequired: false } },
      { fieldName: 'lastupdate', inputType: 'Text', displayName: 'last Update', validationOptions: { isRequired: false } },
      { fieldName: 'u_ts', inputType: 'Text', displayName: 'U Ts', validationOptions: { isRequired: false } },
      { fieldName: 'date_end_date', inputType: 'Date', displayName: 'Date_end_date', validationOptions: { isRequired: false } },
      { fieldName: 'date_modify_date', inputType: 'Date', displayName: 'Date_modify_date', validationOptions: { isRequired: false } },
      { fieldName: 'date_insert_date', inputType: 'Date', displayName: 'Date Insert Date2', validationOptions: { isRequired: false } },
      { fieldName: 'c_uid_Two', inputType: 'Text', displayName: 'C UId Two', validationOptions: { isRequired: false } },
      { fieldName: 'c_tsTwo', inputType: 'Text', displayName: 'C Ts Two', validationOptions: { isRequired: false } },
      { fieldName: 'lastupdateTwo', inputType: 'Text', displayName: 'Last Update Two', validationOptions: { isRequired: false } },
      { fieldName: 'u_tsTwo', inputType: 'Text', displayName: 'U Ts Two', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      num_financier_cd: '', txt_financier_short_name: '', txt_financier_name: '', txt_financier_type: '', txt_status: '', txt_ifsc_code: '', txt_micr_code: '', txt_lisence_no: '', txt_pan_no: '', dat_block_date: '', dat_start_date: '', dat_end_date: '', dat_insert_date: '', dat_modify_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '', date_end_date: '', date_modify_date: '', date_insert_date: '', c_uid_Two: '', c_tsTwo: '', lastupdateTwo: '', u_tsTwo: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      num_financier_cd: '', txt_financier_short_name: '', txt_financier_name: '', txt_financier_type: '', txt_status: '', txt_ifsc_code: '', txt_micr_code: '', txt_lisence_no: '', txt_pan_no: '', dat_block_date: '', dat_start_date: '', dat_end_date: '', dat_insert_date: '', dat_modify_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '', date_end_date: '', date_modify_date: '', date_insert_date: '', c_uid_Two: '', c_tsTwo: '', lastupdateTwo: '', u_tsTwo: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Tata_finance_mastereditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      tata_finance_master_Id: row.tata_finance_master_Id,
      num_financier_cd: row.num_financier_cd, txt_financier_short_name: row.txt_financier_short_name, txt_financier_name: row.txt_financier_name, txt_financier_type: row.txt_financier_type, txt_status: row.txt_status, txt_ifsc_code: row.txt_ifsc_code, txt_micr_code: row.txt_micr_code, txt_lisence_no: row.txt_lisence_no, txt_pan_no: row.txt_pan_no, dat_block_date: row.dat_block_date, dat_start_date: row.dat_start_date, dat_end_date: row.dat_end_date, dat_insert_date: row.dat_insert_date, dat_modify_date: row.dat_modify_date, c_uid: row.c_uid, c_ts: row.c_ts, lastupdate: row.lastupdate, u_ts: row.u_ts, date_end_date: row.date_end_date, date_modify_date: row.date_modify_date, date_insert_date: row.date_insert_date, c_uid_Two: row.c_uid_Two, c_tsTwo: row.c_tsTwo, lastupdateTwo: row.lastupdateTwo, u_tsTwo: row.u_tsTwo,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  Tata_finance_masterfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Tata_finance_master/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  Tata_finance_mastersubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('num_financier_cd', this.state.num_financier_cd);
    formData.append('txt_financier_short_name', this.state.txt_financier_short_name);
    formData.append('txt_financier_name', this.state.txt_financier_name);
    formData.append('txt_financier_type', this.state.txt_financier_type);
    formData.append('txt_status', this.state.txt_status);
    formData.append('txt_ifsc_code', this.state.txt_ifsc_code);
    formData.append('txt_micr_code', this.state.txt_micr_code);
    formData.append('txt_lisence_no', this.state.txt_lisence_no);
    formData.append('txt_pan_no', this.state.txt_pan_no);
    formData.append('dat_block_date', this.state.dat_block_date);
    formData.append('dat_start_date', this.state.dat_start_date);
    formData.append('dat_end_date', this.state.dat_end_date);
    formData.append('dat_insert_date', this.state.dat_insert_date);
    formData.append('dat_modify_date', this.state.dat_modify_date);
    formData.append('c_uid', this.state.c_uid);
    formData.append('c_ts', this.state.c_ts);
    formData.append('lastupdate', this.state.lastupdate);
    formData.append('u_ts', this.state.u_ts);
    formData.append('date_end_date', this.state.date_end_date);
    formData.append('date_modify_date', this.state.date_modify_date);
    formData.append('date_insert_date', this.state.date_insert_date);
    formData.append('c_uid_Two', this.state.c_uid_Two);
    formData.append('c_tsTwo', this.state.c_tsTwo);
    formData.append('lastupdateTwo', this.state.lastupdateTwo);
    formData.append('u_tsTwo', this.state.u_tsTwo);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Tata_finance_master/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Tata_finance_masterfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ num_financier_cd: '', txt_financier_short_name: '', txt_financier_name: '', txt_financier_type: '', txt_status: '', txt_ifsc_code: '', txt_micr_code: '', txt_lisence_no: '', txt_pan_no: '', dat_block_date: '', dat_start_date: '', dat_end_date: '', dat_insert_date: '', dat_modify_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '', date_end_date: '', date_modify_date: '', date_insert_date: '', c_uid_Two: '', c_tsTwo: '', lastupdateTwo: '', u_tsTwo: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  Tata_finance_masterupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tata_finance_master_Id", this.state.tata_finance_master_Id);
    formData.append('num_financier_cd', this.state.num_financier_cd);
    formData.append('txt_financier_short_name', this.state.txt_financier_short_name);
    formData.append('txt_financier_name', this.state.txt_financier_name);
    formData.append('txt_financier_type', this.state.txt_financier_type);
    formData.append('txt_status', this.state.txt_status);
    formData.append('txt_ifsc_code', this.state.txt_ifsc_code);
    formData.append('txt_micr_code', this.state.txt_micr_code);
    formData.append('txt_lisence_no', this.state.txt_lisence_no);
    formData.append('txt_pan_no', this.state.txt_pan_no);
    formData.append('dat_block_date', this.state.dat_block_date);
    formData.append('dat_start_date', this.state.dat_start_date);
    formData.append('dat_end_date', this.state.dat_end_date);
    formData.append('dat_insert_date', this.state.dat_insert_date);
    formData.append('dat_modify_date', this.state.dat_modify_date);
    formData.append('c_uid', this.state.c_uid);
    formData.append('c_ts', this.state.c_ts);
    formData.append('lastupdate', this.state.lastupdate);
    formData.append('u_ts', this.state.u_ts);
    formData.append('date_end_date', this.state.date_end_date);
    formData.append('date_modify_date', this.state.date_modify_date);
    formData.append('date_insert_date', this.state.date_insert_date);
    formData.append('c_uid_Two', this.state.c_uid_Two);
    formData.append('c_tsTwo', this.state.c_tsTwo);
    formData.append('lastupdateTwo', this.state.lastupdateTwo);
    formData.append('u_tsTwo', this.state.u_tsTwo);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Tata_finance_master/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Tata_finance_masterfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.Tata_finance_masterfetchHandler();

    //***componentDidMount
  }

  handlenum_financier_cdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_financier_cd: fieldValue });
  }; handletxt_financier_short_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_financier_short_name: fieldValue });
  }; handletxt_financier_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_financier_name: fieldValue });
  }; handletxt_financier_typeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_financier_type: fieldValue });
  }; handletxt_statusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_status: fieldValue });
  }; handletxt_ifsc_codeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_ifsc_code: fieldValue });
  }; handletxt_micr_codeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_micr_code: fieldValue });
  }; handletxt_lisence_noChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_lisence_no: fieldValue });
  }; handletxt_pan_noChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_pan_no: fieldValue });
  }; handledat_block_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_block_date: fieldValue });
  }; handledat_start_dateChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dat_start_date: fieldValue });
  }; handledat_end_dateChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dat_end_date: fieldValue });
  }; handledat_insert_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_insert_date: fieldValue });
  }; handledat_modify_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_modify_date: fieldValue });
  }; handlec_uidChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ c_uid: fieldValue });
  }; handlec_tsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ c_ts: fieldValue });
  }; handlelastupdateChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ lastupdate: fieldValue });
  }; handleu_tsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ u_ts: fieldValue });
  }; handledate_end_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ date_end_date: fieldValue });
  }; handledate_modify_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ date_modify_date: fieldValue });
  }; handledate_insert_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ date_insert_date: fieldValue });
  }; handlec_uid_TwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ c_uid_Two: fieldValue });
  }; handlec_tsTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ c_tsTwo: fieldValue });
  }; handlelastupdateTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ lastupdateTwo: fieldValue });
  }; handleu_tsTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ u_tsTwo: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this tata_finance_master?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('tata_finance_master_Id', row.tata_finance_master_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Tata_finance_master/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Tata_finance_masterfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>TATA Finance Master</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Tata_finance_master</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Financier Cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_financier_cdChange} className="form-control" name="num_financier_cd" value={this.state.num_financier_cd} required="required" placeholder="Enter Number Financier Cd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_financier_cd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Financier Short Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_financier_short_nameChange} className="form-control" name="txt_financier_short_name" value={this.state.txt_financier_short_name} required="required" placeholder="Enter Text Financier Short Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_financier_short_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Financier Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_financier_nameChange} className="form-control" name="txt_financier_name" value={this.state.txt_financier_name} required="required" placeholder="Enter Text Financier Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_financier_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Financier Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_financier_typeChange} className="form-control" name="txt_financier_type" value={this.state.txt_financier_type} required="required" placeholder="Enter Text Financier Type" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_financier_type} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Status</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_statusChange} className="form-control" name="txt_status" value={this.state.txt_status} required="required" placeholder="Enter Text Status" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_status} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text IFSC Code</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_ifsc_codeChange} className="form-control" name="txt_ifsc_code" value={this.state.txt_ifsc_code} required="required" placeholder="Enter Text IFSC Code" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_ifsc_code} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Micr Code</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_micr_codeChange} className="form-control" name="txt_micr_code" value={this.state.txt_micr_code} required="required" placeholder="Enter Text Micr Code" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_micr_code} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Lisence Number</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_lisence_noChange} className="form-control" name="txt_lisence_no" value={this.state.txt_lisence_no} required="required" placeholder="Enter Text Lisence Number" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_lisence_no} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text PAN Number</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_pan_noChange} className="form-control" name="txt_pan_no" value={this.state.txt_pan_no} required="required" placeholder="Enter Text PAN Number" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_pan_no} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Block Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_block_dateChange} className="form-control" name="dat_block_date" value={this.state.dat_block_date} required="required" placeholder="Enter Date Block Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_block_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Start Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledat_start_dateChange} className="form-control" name="dat_start_date" value={this.state.dat_start_date} required="required" placeholder="Enter Date Start Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_start_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date End Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledat_end_dateChange} className="form-control" name="dat_end_date" value={this.state.dat_end_date} required="required" placeholder="Enter Date End Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_end_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Insert Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_insert_dateChange} className="form-control" name="dat_insert_date" value={this.state.dat_insert_date} required="required" placeholder="Enter Date Insert Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_insert_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Modify Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_modify_dateChange} className="form-control" name="dat_modify_date" value={this.state.dat_modify_date} required="required" placeholder="Enter Date Modify Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_modify_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>C Uid</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlec_uidChange} className="form-control" name="c_uid" value={this.state.c_uid} required="required" placeholder="Enter C Uid" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_uid} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>C Ts</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlec_tsChange} className="form-control" name="c_ts" value={this.state.c_ts} required="required" placeholder="Enter C Ts" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_ts} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>last Update</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlelastupdateChange} className="form-control" name="lastupdate" value={this.state.lastupdate} required="required" placeholder="Enter last Update" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.lastupdate} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>U Ts</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleu_tsChange} className="form-control" name="u_ts" value={this.state.u_ts} required="required" placeholder="Enter U Ts" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.u_ts} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date_end_date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledate_end_dateChange} className="form-control" name="date_end_date" value={this.state.date_end_date} required="required" placeholder="Enter Date_end_date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.date_end_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date_modify_date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledate_modify_dateChange} className="form-control" name="date_modify_date" value={this.state.date_modify_date} required="required" placeholder="Enter Date_modify_date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.date_modify_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Insert Date2</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledate_insert_dateChange} className="form-control" name="date_insert_date" value={this.state.date_insert_date} required="required" placeholder="Enter Date Insert Date2" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.date_insert_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>C UId Two</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlec_uid_TwoChange} className="form-control" name="c_uid_Two" value={this.state.c_uid_Two} required="required" placeholder="Enter C UId Two" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_uid_Two} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>C Ts Two</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlec_tsTwoChange} className="form-control" name="c_tsTwo" value={this.state.c_tsTwo} required="required" placeholder="Enter C Ts Two" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_tsTwo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Last Update Two</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlelastupdateTwoChange} className="form-control" name="lastupdateTwo" value={this.state.lastupdateTwo} required="required" placeholder="Enter Last Update Two" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.lastupdateTwo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>U Ts Two</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleu_tsTwoChange} className="form-control" name="u_tsTwo" value={this.state.u_tsTwo} required="required" placeholder="Enter U Ts Two" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.u_tsTwo} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Tata_finance_mastersubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Tata_finance_master</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Financier Cd</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_financier_cdChange} className="form-control" name="num_financier_cd" value={this.state.num_financier_cd} required="required" placeholder="Enter Number Financier Cd" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_financier_cd} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Financier Short Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_financier_short_nameChange} className="form-control" name="txt_financier_short_name" value={this.state.txt_financier_short_name} required="required" placeholder="Enter Text Financier Short Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_financier_short_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Financier Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_financier_nameChange} className="form-control" name="txt_financier_name" value={this.state.txt_financier_name} required="required" placeholder="Enter Text Financier Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_financier_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Financier Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_financier_typeChange} className="form-control" name="txt_financier_type" value={this.state.txt_financier_type} required="required" placeholder="Enter Text Financier Type" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_financier_type} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Status</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_statusChange} className="form-control" name="txt_status" value={this.state.txt_status} required="required" placeholder="Enter Text Status" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_status} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text IFSC Code</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_ifsc_codeChange} className="form-control" name="txt_ifsc_code" value={this.state.txt_ifsc_code} required="required" placeholder="Enter Text IFSC Code" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_ifsc_code} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Micr Code</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_micr_codeChange} className="form-control" name="txt_micr_code" value={this.state.txt_micr_code} required="required" placeholder="Enter Text Micr Code" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_micr_code} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Lisence Number</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_lisence_noChange} className="form-control" name="txt_lisence_no" value={this.state.txt_lisence_no} required="required" placeholder="Enter Text Lisence Number" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_lisence_no} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text PAN Number</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_pan_noChange} className="form-control" name="txt_pan_no" value={this.state.txt_pan_no} required="required" placeholder="Enter Text PAN Number" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_pan_no} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Block Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_block_dateChange} className="form-control" name="dat_block_date" value={this.state.dat_block_date} required="required" placeholder="Enter Date Block Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_block_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Start Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledat_start_dateChange} className="form-control" name="dat_start_date" value={this.state.dat_start_date} required="required" placeholder="Enter Date Start Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_start_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date End Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledat_end_dateChange} className="form-control" name="dat_end_date" value={this.state.dat_end_date} required="required" placeholder="Enter Date End Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_end_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Insert Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_insert_dateChange} className="form-control" name="dat_insert_date" value={this.state.dat_insert_date} required="required" placeholder="Enter Date Insert Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_insert_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Modify Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_modify_dateChange} className="form-control" name="dat_modify_date" value={this.state.dat_modify_date} required="required" placeholder="Enter Date Modify Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_modify_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>C Uid</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlec_uidChange} className="form-control" name="c_uid" value={this.state.c_uid} required="required" placeholder="Enter C Uid" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_uid} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>C Ts</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlec_tsChange} className="form-control" name="c_ts" value={this.state.c_ts} required="required" placeholder="Enter C Ts" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_ts} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>last Update</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlelastupdateChange} className="form-control" name="lastupdate" value={this.state.lastupdate} required="required" placeholder="Enter last Update" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.lastupdate} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>U Ts</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleu_tsChange} className="form-control" name="u_ts" value={this.state.u_ts} required="required" placeholder="Enter U Ts" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.u_ts} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date_end_date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledate_end_dateChange} className="form-control" name="date_end_date" value={this.state.date_end_date} required="required" placeholder="Enter Date_end_date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.date_end_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date_modify_date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledate_modify_dateChange} className="form-control" name="date_modify_date" value={this.state.date_modify_date} required="required" placeholder="Enter Date_modify_date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.date_modify_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Insert Date2</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledate_insert_dateChange} className="form-control" name="date_insert_date" value={this.state.date_insert_date} required="required" placeholder="Enter Date Insert Date2" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.date_insert_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>C UId Two</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlec_uid_TwoChange} className="form-control" name="c_uid_Two" value={this.state.c_uid_Two} required="required" placeholder="Enter C UId Two" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_uid_Two} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>C Ts Two</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlec_tsTwoChange} className="form-control" name="c_tsTwo" value={this.state.c_tsTwo} required="required" placeholder="Enter C Ts Two" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_tsTwo} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Last Update Two</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlelastupdateTwoChange} className="form-control" name="lastupdateTwo" value={this.state.lastupdateTwo} required="required" placeholder="Enter Last Update Two" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.lastupdateTwo} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>U Ts Two</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleu_tsTwoChange} className="form-control" name="u_tsTwo" value={this.state.u_tsTwo} required="required" placeholder="Enter U Ts Two" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.u_tsTwo} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.Tata_finance_masterupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}